import React from 'react';

/**
 * The repeat glyph every task-set chip carries. Extracted because it was inlined
 * verbatim in TaskSetChip and TaskSetNameChip, and PIKA-789's modal chip would
 * have been a third copy. Colour comes from the chip through `currentColor`, so
 * the icon needs no prop and never disagrees with its pill.
 */
export const TaskSetRepeatIcon = () => (
	<svg
		width="11"
		height="11"
		viewBox="0 0 16 16"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.8"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-hidden="true"
		style={{flexShrink: 0}}
	>
		<path d="M3 8a5 5 0 0 1 8.4-3.7M13 8a5 5 0 0 1-8.4 3.7" />
		<path d="M11.6 2.2v2.4H9.2M4.4 13.8v-2.4h2.4" />
	</svg>
);
